document.addEventListener('DOMContentLoaded', function () {
    const quantityOptions = document.querySelectorAll('.quantity__option');
    const quantityInputs = document.querySelectorAll('input[data-quantity-input]');

    function updatePrice(quantity, quantityInput) {
        const basePrice = parseFloat(quantityInput.dataset.price) / 100;
        const discountPercentage = parseFloat(quantityInput.dataset.discountPercentage) || 10;

        let totalPrice = basePrice * quantity;

        if (quantity > 1) {
            const discountStep = quantity - 1;
            const currentDiscount = discountStep * discountPercentage;
            const discountMultiplier = 1 - (currentDiscount / 100);
            totalPrice = totalPrice * discountMultiplier;
        }

        const moneyFormat = Shopify.formatMoney(totalPrice * 100, window.money_format);

        const priceElement = document.querySelector('.price--medium .price__regular .price-item--regular');
        if (priceElement) priceElement.textContent = moneyFormat;

        const subtotalElement = document.querySelector('.productView-subtotal .money-subtotal');
        if (subtotalElement) subtotalElement.textContent = moneyFormat;

        const stickyPrice = document.querySelector('[data-sticky-add-to-cart] .money-subtotal');
        if (stickyPrice) stickyPrice.textContent = moneyFormat;
    }

    // Handle quantity options (stacked style)
    quantityOptions.forEach(option => {
        option.addEventListener('click', function () {
            const quantity = parseInt(this.dataset.quantity);

            // Remove 'selected' class from ALL options with the same parent block
            document.querySelectorAll('.quantity__option[data-quantity]').forEach(opt => {
                if (opt.dataset.quantity === String(quantity)) {
                    opt.classList.add('selected');
                } else {
                    opt.classList.remove('selected');
                }
            });

            // Set all quantity inputs to the selected quantity
            quantityInputs.forEach(input => {
                input.value = quantity;
            });

            if (quantityInputs.length > 0) {
                updatePrice(quantity, quantityInputs[0]);
                quantityInputs[0].dispatchEvent(new Event('change'));
            }
        });
    });

    // Handle quantity input changes (manual input only)
    quantityInputs.forEach(input => {
        // Only handle direct input changes, let the custom element handle button clicks
        input.addEventListener('change', function() {
            const quantity = parseInt(this.value);
            if (quantity > 0) {
                updatePrice(quantity, this);
            }
        });
    });

    // Set the default selected state for all groups
    const defaultQuantity = 1;
    document.querySelectorAll(`.quantity__option[data-quantity="${defaultQuantity}"]`).forEach(opt => {
        opt.classList.add('selected');
    });

    if (quantityInputs.length > 0) {
        updatePrice(defaultQuantity, quantityInputs[0]);
    }
});
